import Carousel from '../components/Carousel.js';
import ConcertTeaser from "../images/ConcertTeaser.jpg";
import StayInTouch from "../components/StayInTouch";

export default function Home() {
  return (
    <div>
      <body style={{textAlign: 'left'}}>
        <Carousel/>
        <div style={{margin: '10vh'}}>
          <h2><strong>Hello!</strong></h2>
          <p style={{fontSize: '21px'}}>Based in Boston, Massachusetts, the <strong>Horizon Ensemble</strong> performs music of history and music by friends. We believe in enriching our communities of musicians and audiences and supporting the development of young living composers!</p>
        </div>
      </body>
      <body className='outreach'>
        <img src={ConcertTeaser} className='ensemble-picture' style={{margin: "10vh", minHeight: "75vh"}}/>
        <div style={{margin: '10vh'}}>
          <h3><strong><u>Horizon Ensemble: Rediscoveries</u><br/>
          Saturday, September 20, 2025 at 3:00 PM</strong></h3>
          <p>
            <i>"The moments of the past do not remain still..."</i><br/><br/>
            As the summer season wanes, let's open the Horizon Ensemble's fifth concert season with <strong><i>Rediscoveries!</i></strong> In this season opener, we rediscover images and melodies of the past, combined with 
            modern styles and perspectives. Join us on <strong>Saturday, September 20 at 3:00 PM</strong> in the <strong>Church of the
            Covenant</strong> in Back Bay for a colorful, storied concert.<br/><br/>
            
            We begin with the <strong>Overture to <i>The Anonymous Lover</i></strong> by <strong>Joseph Bologne,</strong> a swordfighting, violin-
            shredding composer of 18th-century France. Next, our friend <strong>Tomer Rozen's <i>Comedy</i></strong> mixes old 
            musical aesthetics with wacky new rhythms & harmonies. The bright-eyed <strong>Piano Concerto</strong> of 
            <strong>Germaine Tailleferre</strong> dazzles and dances, featuring pianist <strong>Yuseok Seol.</strong> We finish with the momentous 
            <strong>Organ Symphony</strong> by <strong>Camille Saint-Saëns,</strong> featuring the Church of the Covenant's historic 3,530-pipe 
            organ!

          <br/><br/>Get Rediscoveries tickets <a href="https://www.eventbrite.com/e/horizon-ensemble-rediscoveries-tickets-1636899724139?aff=ebdsoporgprofile">here!</a>
          </p><br/><br/>
          </div>
      </body>
      <body className='season'>
        <a style={{color: "white"}} href="https://calendar.google.com/calendar/embed?src=horizonensembleboston%40gmail.com&ctz=UTC"><h3><u>Learn more about the Horizon Ensemble’s 2024–2025 season!</u></h3></a>
        </body>
      <body className='youtube'>
        <div className="displays">
          <h4 style={{fontSize: "21px"}}><strong>From a previous concert: 
            <br/>Florence Price’s The Oak <br/></strong></h4>
            <p>A mysterious orchestral exploration of history and dreams...
            </p>
            <div class="embed-responsive embed-responsive-16by9">
              <iframe class="embed-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/vmaTdD_bC70?si=xj49QvZhAfLAyDv4" allowfullscreen></iframe>
              </div>
        </div>
        <div className="displays">
          <h4 style={{fontSize: "21px"}}><strong>Throwback to summer 2023: <br/></strong></h4>
          <p>A  lively Serenade for wind instruments, <br/>
            written by 4 Horizon composer friends!
            </p>
            <div class="embed-responsive embed-responsive-16by9">
              <iframe class="embed-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/I9Rt2kAbbbc?si=oyUUlG9bMeZta9At" allowfullscreen></iframe>
              </div>
        </div>
      </body>
      <StayInTouch/>
    </div>
  );
}
